const ITEMS = ["Svatby", "Oslavy", "Zahradní párty", "Firemní akce", "Narozeniny", "Soukromé večeře", "Rauty", "Live cooking"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee" className="border-y border-[var(--line)] py-7 overflow-hidden bg-[var(--surface)]">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {row.map((t, i) => (
          <span key={i} className="flex items-center font-display text-3xl md:text-5xl font-light uppercase tracking-tight">
            <span className={i % 2 ? "text-outline" : ""}>{t}</span>
            <svg viewBox="0 0 20 20" className="w-5 h-5 mx-8 md:mx-12 shrink-0"><path d="M10 0 L12 8 L20 10 L12 12 L10 20 L8 12 L0 10 L8 8Z" fill="#C08A2E" /></svg>
          </span>
        ))}
      </div>
    </section>
  );
};
